import React from 'react';
import { Link } from 'react-router-dom';
import { useGoToHome } from '../../hooks/useGoToHome';
import { useGoToHomeSection } from '../../hooks/useGoToHomeSection';
import './lv2-nav.css';

const Lv2Nav = () => {
  const goToHome = useGoToHome();
  const goToHomeSection = useGoToHomeSection();

  const handleSectionClick = (sectionId) => (event) => {
    event.preventDefault();
    goToHomeSection(sectionId);
  };

  return (
    <nav className="lv2-nav" aria-label="Основная навигация">
      <button type="button" className="lv2-nav-logo" onClick={goToHome}>
        market<em>Dir</em>
        <span className="lv2-nav-slogan">Знает, что делать</span>
      </button>
      <ul className="lv2-nav-links">
        <li>
          <a href="#how" onClick={handleSectionClick('how')}>
            Как работает
          </a>
        </li>
        <li>
          <a href="#plan" onClick={handleSectionClick('plan')}>
            План роста
          </a>
        </li>
        <li>
          <a href="#tools" onClick={handleSectionClick('tools')}>
            Инструменты
          </a>
        </li>
        <li>
          <Link to="/about">Обо мне</Link>
        </li>
        <li>
          <a href="#widget" className="lv2-nav-cta" onClick={handleSectionClick('widget')}>
            Начать диагностику
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Lv2Nav;
